import { createSelectors } from '@mri-platform/shared/entity';
import { JobLog } from '../../models';

export const jobLogSelectors = createSelectors(JobLog);
